import { render } from "./RegionTable.vue?vue&type=template&id=9892f878&scoped=true&ts=true"
import script from "./RegionTable.ts?vue&type=script&lang=ts"
export * from "./RegionTable.ts?vue&type=script&lang=ts"

import "./RegionTable.scss?vue&type=style&index=0&id=9892f878&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9892f878"]])

export default __exports__